import { Confetti } from 'stimulus-confetti'

export default class extends Confetti {
  static values = {
    ...Confetti.values,
    follow: { type: Boolean, default: false },
  }

  connect() {
    this.spray(new CustomEvent("fake"))
  }
}
